module.exports = __webpack_public_path__ + "static/media/team3.351e7bd5.jpg";